import { Injectable } from '@angular/core'; 
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

import { environment } from './environments/environment';
//import {Observable} from 'rxjs';
//import 'rxjs/add/operator/map';
import { User } from './user.model';

@Injectable()
export class UserService {
  readonly rootUrl = environment.apiUrl;// 'https://localhost:44318/'; 
  constructor(private http: HttpClient) { }

  registerUser(user : User){
 
 
user.Role = 'User';
    // const body: User = {
    //   UserName: user.UserName,
    //   Password: user.Password,
    //   Age: user.Age,
    //    Email: user.Email, 
    //    Role:'User',
    //   FirstName: user.FirstName,
    //   RefferedBy: user.RefferedBy,
    //   LastName: user.LastName,
     
    // }
    //return this.http.post(this.rootUrl + '/users/Register', body);
 console.log(user);
 
    return this.http.post(this.rootUrl + 'users/Register', user);
     
  }

}